<template>
  <a-card>
    <span slot="title"
      >Simulation {{ mode === "Create" ? "Create" : "Change" }} Form</span
    >
    <a-steps :current="current" status="process">
      <a-step title="Simulation Information" />
      <a-step title="Simulation Details" />
    </a-steps>
    <div
      :class="
        steps[current].content === 'Header'
          ? 'padding-remove steps-content flex-1'
          : 'steps-content flex-1'
      "
    >
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button-group>
          <a-button
            :loading="btnLoadingSaveDraft"
            v-if="current == steps.length - 1"
            type="default"
            @click="validateDraft"
            >Save Draft</a-button
          >
          <a-button
            :loading="btnLoadingSave"
            v-if="current == steps.length - 1"
            type="primary"
            @click="validate"
            >Release</a-button
          >
        </a-button-group>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Header from "./steps/Header.vue";
import DetilSimulasi from "./steps/DetilSimulasi.vue";
import moment from "moment";

export default {
  name: "anggaranCreate",
  props: ["id","thn","id_template"],
  components: {
    DetilSimulasi,
    Header,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Header",
          content: "Header",
        },
        {
          title: "DetilSimulasi",
          content: "DetilSimulasi",
        },
      ],
      btnLoadingSave: false,
      btnLoadingSaveDraft: false,
      mode: "Create",
      collectData: {},
      methodeSave:"draft",
      dataEdit:[],
    };
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchData();
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDateTimeFormat",
    ]),
    stepProps() {
      let step = {};
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Header") {
          step = {
            submitdata : this.collectData.submitValue,
            data: this.collectData.header,
            info: this.collectData.info,
            mode: this.mode,
            id:this.id,
            id_template: this.id_template,
            thn_template: this.thn,
            dataEdit: this.dataEdit,
          };
        } else if (this.steps[this.current].content === "DetilSimulasi") {
          step = {
            submitdata : this.collectData.submitValue,
            data: this.collectData.header,
            info: this.collectData.info,
            mode: this.mode,
            id:this.id,
            thn_template: this.thn,
            id_template: this.id_template,
            dataEdit: this.dataEdit,
          };
        }
      } else {
        if (this.steps[this.current].content === "Header") {
          step = {
            submitdata : this.collectData.submitValue,
            data: this.collectData.header,
            info: this.collectData.info,
            mode: this.mode,
            id_template: this.id_template,
            thn_template: this.collectData.header ? this.collectData.header.year : this.thn,
          };
        } else if (this.steps[this.current].content === "DetilSimulasi") {
          step = {
            submitdata : this.collectData.submitValue,
            data: this.collectData.header,
            info: this.collectData.info,
            mode: this.mode,
            id_template: this.id_template,
            thn_template: this.collectData.header ? this.collectData.header.year : this.thn,
          };
        }
      }

      return step;
    },
    stepRef() {
      let ref = "";
      if (this.steps[this.current].content === "Header") {
        ref = "refHeader";
      } else if (this.steps[this.current].content === "DetilSimulasi") {
        ref = "refDetilSimulasi";
      }

      return ref;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + (this.mode=="Edit" ? "simulasi/manifest" :"simulasi"),
        params: {
          tahun: parseInt(this.thn),
          id_simulasi : this.id,
          jenis: "edit"
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataEdit = response.data;
          this.collectData = {
            header: {
              year : response.data.tahun.toString(),
              simulation_nm : response.data.simulation_nm,
              note : response.data.catatan,
            }
          };
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    next() {
      if (this.steps[this.current].content === "Header") {
        this.$refs.refHeader.handleRef();
      } else if (this.steps[this.current].content === "DetilSimulasi") {
        this.$refs.refDetilSimulasi.handleRef();
      }
    },
    prev() {
      if (this.steps[this.current].content === "DetilSimulasi") {
        this.$refs.refDetilSimulasi.handleRef();
      }
      this.current--;
    },
    validate() {
      this.methodeSave = "non_draft";
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else if (this.mode === "Create") {
        this.confirmMessage("confirm-save");
      }
    },
    validateDraft() {
      this.methodeSave = "draft";
      this.confirmMessage("confirm-save-draft");
    },
    valueFromChildBack(value) {
      // if (this.steps[this.current].content === "Header") {
      //   this.collectData.informasi = value;
      // }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Header") {
        this.collectData.header = value.inputHeader;
        //this.collectData.info = value.jenis;
        this.current++;
      } else if (this.steps[this.current].content === "DetilSimulasi") {
        this.collectData.submitValue = value.submitValue;
        if (this.methodeSave == 'draft'){
          this.collectData.submitValue.jenis='draft';
        }else{
          this.collectData.submitValue.jenis='non_draft';
        }
      }
    },
    submit() {
      this.$refs.refDetilSimulasi.handleRef();
        if ((this.collectData.submitValue.jenis=='non_draft' && this.collectData.submitValue.validatorUtang[0]) || 
          this.collectData.submitValue.jenis=='draft'){
        
          //validasi jika pendanaan masih kosong
          let saldosetelahpendanaan = 0
          this.collectData.submitValue.tree.forEach(element => {
            if(element.nameitem == "Saldo Sesudah Pendanaan"){
              saldosetelahpendanaan = parseFloat(element["bln"+this.collectData.header.year+"12"][1])
            }
          })
          if (saldosetelahpendanaan<= 0 && this.collectData.submitValue.jenis=='non_draft'){
            this.displayMessage("emptyPendanaan")
          }else{
            this.btnLoadingSave = true;
            axios({
              method: "post",
              url: this.$serviceUrl + "simulasi",
              processData: false,
              data: this.collectData.submitValue,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
            .then((response) => {
              console.log(response);
              if (this.mode === "Create") {
                this.displayMessage("success-save");
              } else {
                this.displayMessage("success-edit");
              }
              //Event.$emit("rabkeepalive", false);
              this.btnLoadingSave = false;
              this.$router.push({ name: "simulasianggaranAcc" });
            })
            .catch((err) => {
              let response = Object.assign({}, err.response.data);
              if (
                response.message.includes("kode proyek sudah pernah digunakan")
              ) {
                this.displayMessage("error-exist_project_code");
              }
              this.btnLoadingSave = false;
            });
          }
      }else{
        this.displayMessage("warning-valadatorUtang");
      }
    },
  },
  mounted() {
    Event.$on("headerform", this.valueFromChild);
    Event.$on("projectrabBack", this.valueFromChildBack);
    Event.$on("refresh", this.fetchData);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("headerform", this.valueFromChild);
    Event.$off("projectrabBack", this.valueFromChildBack);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style>
</style>